<template>
  <div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 4rem; height: 4rem;" variant="info"></b-spinner>
		</div>
    <div v-else class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header">
						<div class="animated fadeIn">
							<genericTableInvoice :table-data="unapprovedTableData" :filter="true" :fields="unapprovedListFields" :search-method="setUnapprovedListPagination" hover striped bordered small
														caption="<i class='icon-list'></i> Unapproved Invoices">
								<template slot="row-actions" slot-scope="row">
									<b-button size="sm" variant="success" active v-b-modal.invoice-editor @click="passDataToModal(row.row.item.invoice_id)" class="mr-1">
										<i class="icon-check"></i> Approve
									</b-button>
								</template>
							</genericTableInvoice>
							<b-modal id="invoice-editor" title="Edit Invoice" @ok="editInvoice" ok-title="Save" @cancel="clearModalData">
								<form action="">
									<b-form-group label="Invoice No" :horizontal="true" label-for="invoiceNo">
										<b-form-input name="invoiceNo" id="invoiceNo" type="text" :state="!errors.has('invoiceNo')" v-model="selectedInvoiceToEdit.invoiceNumber" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('invoiceNo')">{{errors.first('invoiceNo')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Bill Amount" :horizontal="true" label-for="billAmount">
										<b-form-input name="billAmount" id="billAmount" type="number" v-validate="{required:true,min:0.0}" :state="!errors.has('billAmount')" v-model="selectedInvoiceToEdit.billAmount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('billAmount')">{{errors.first('billAmount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="SD Amount" :horizontal="true" label-for="sdAmount">
										<b-form-input name="sdAmount" id="sdAmount" type="number" v-validate="{min:0.0}" :state="!errors.has('sdAmount')" v-model="selectedInvoiceToEdit.sdAmount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('sdAmount')">{{errors.first('sdAmount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Vat Amount" :horizontal="true" label-for="vatAmount">
										<b-form-input name="vatAmount" id="vatAmount" type="number" v-validate="{required:true,min:0.0}" :state="!errors.has('vatAmount')" v-model="selectedInvoiceToEdit.vatAmount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('vatAmount')">{{errors.first('vatAmount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Discount Amount" :horizontal="true" label-for="totalDiscount">
										<b-form-input name="totalDiscount" id="totalDiscount" type="number" v-validate="{required:true,min:0.0}" :state="!errors.has('totalDiscount')" v-model="selectedInvoiceToEdit.totalDiscount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('totalDiscount')">{{errors.first('totalDiscount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Total Amount" :horizontal="true" label-for="totalAmount">
										<b-form-input name="totalAmount" id="totalAmount" type="number" v-validate="{required:true,min:0.0}" :state="!errors.has('totalAmount')" v-model="selectedInvoiceToEdit.totalAmount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('totalAmount')">{{errors.first('totalAmount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Total Paid Amount" :horizontal="true" label-for="totalPaidAmount">
										<b-form-input name="totalPaidAmount" id="totalPaidAmount" type="number" v-validate="{required:true,min:0.0}" :state="!errors.has('totalPaidAmount')" v-model="selectedInvoiceToEdit.totalPaidAmount" trim></b-form-input>
										<b-form-invalid-feedback v-show="errors.has('totalPaidAmount')">{{errors.first('totalPaidAmount')}}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Remarks" :horizontal="true" label-for="remarks">
										<b-form-textarea name="remarks" id="remarks" type="text" :state="!errors.has('remarks')" v-model="selectedInvoiceToEdit.remarks" trim></b-form-textarea>
										<b-form-invalid-feedback v-show="errors.has('remarks')">{{errors.first('remarks')}}</b-form-invalid-feedback>
									</b-form-group>
								</form>
							</b-modal>
						</div>
          </b-card>
        </b-col>
      </b-row>
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div class="animated fadeIn">
							<genericTableInvoice :table-data="unpaidTableData" :filter="true" :fields="unpaidListFields" :search-method="setUnpaidListPagination" hover striped bordered small
														caption="<i class='icon-list'></i> Unpaid Invoices">
								<template v-slot:row-actions="row">
									<b-button size="sm" variant="info" class="mr-1" @click="downloadInvoice(row.row.item.invoice_id)">
										<i class="fa fa-download"></i> Download
									</b-button>
								</template>
							</genericTableInvoice>
						</div>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header"><i class="icon-eye"></i> Check Invoices</div>
						<b-form-group
							label="Select Project"
							label-for="projectName"
							:label-cols="3"
							:horizontal="true">
<!--							<b-form-select v-model="projectId"-->
<!--														 id="projectName"-->
<!--														 :plain="true"-->
<!--														 :options="projectNameDropDownList"-->
<!--														 value="Please select"-->
<!--														 @change="getInvoicesOfAProject">-->
<!--							</b-form-select>-->
							<model-select id="projectName" :options="projectNameDropDownList" v-model="projectId" placeholder="Select Project Name"></model-select>
						</b-form-group>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12" v-if="projectId != null">
					<b-card header-tag="header">
						<div class="animated fadeIn">
							<genericTableInvoice :table-data="projectwiseTableData" :fields="projectwiseInvoiceListFields" :per-page=10 hover striped bordered small
														:busy="loadingProjectInvoices"
														:caption="'<i class=\'icon-list\'></i> Invoices of ' + projectNames[projectId]">
							</genericTableInvoice>
						</div>
					</b-card>
				</b-col>
			</b-row>
    </div>
  </div>
</template>

<script>
import invoiceService from '@/services/invoiceService';
import officeService from '@/services/officeService';
import toastService from '@/services/toastService';
import genericTableInvoice from '@/components/GenericTableInvoice';
import moment from 'moment';
import customerService from "@/services/customerService";
import {ModelSelect} from "vue-search-select";

export default {
  name: 'invoice',
	components: {
		"genericTableInvoice": genericTableInvoice,
		ModelSelect
	},
	data: function () {
		return {
			unapprovedInvoiceList  : [],
			unapprovedInvoiceModalList:[],
			selectedInvoiceToEdit : {},
			unpaidInvoiceList      : [],
			projectwiseInvoiceList : [],
			unapprovedListFields   : [
				{key: 'invoice_id', label: 'Invoice ID', sortable: true},
				{key: 'project_name', label: 'Project Name', sortable: true},
				{key: 'bill_generation_date', label: 'Bill Generation Date', sortable: true},
				{key: 'bill_amount', label: 'Bill Amount', sortable: true},
				{key: 'bill_payment_last_date', label: 'Last Date of Payment', sortable: true},
				{key: 'actions', label: 'Action', sortable: false}
			],
			unpaidListFields             : [
				{key: 'invoice_id', label: 'Invoice ID', sortable: true},
				{key: 'project_name', label: 'Project Name', sortable: true},
				{key: 'bill_generation_date', label: 'Bill Generation Date', sortable: true},
				{key: 'bill_amount', label: 'Bill Amount', sortable: true},
				{key: 'sd_amount', label: 'SD Amount', sortable: true},
				{key: 'total_amount', label: 'Total Amount (including VAT)', sortable: true},
				{key: 'total_paid_amount', label: 'Paid', sortable: true},
				{key: 'total_discount', label: 'Discount', sortable: true},
				{key: 'due_amount', label: 'Due', sortable: true},
				{key: 'actions', label: 'Actions', class : 'text-center'}
			],
			projectwiseInvoiceListFields : [
				{key: 'invoice_id', label: 'Invoice ID', sortable: true},
				{key: 'bill_generation_date', label: 'Bill Generation Date', sortable: true},
				{key: 'bill_amount', label: 'Bill Amount', sortable: true},
				{key: 'late_fee', label: 'Late Fee', sortable: true},
				{key: 'total_amount', label: 'Total Amount', sortable: true},
				{key: 'total_paid_amount', label: 'Paid', sortable: true},
				{key: 'total_discount', label: 'Discount', sortable: true},
				{key: 'due_amount', label: 'Due', sortable: true},
				{key: 'approval_status', label: 'Approval Status', sortable: true},
				{key: 'payment_status', label: 'Payment Status', sortable: true}
			],
			projectId: null,
			officeDropDownList: [ {text: 'Please select', value: null} ],
			officeNameList: [],
			projectNames : [],
			// projectNameDropDownList : [ {text: 'Please select', value: null} ],
			projectNameDropDownList : [],
			selectedOfficeName: null,
			loading: false,
			loadingProjectInvoices: false,
			unapprovedListPerPage: 10,
			unapprovedListPageNumber: 0,
			unapprovedListSearchKey: "",
			unapprovedListTotal: 0,
			unapprovedListTotalPages: 0,
			unpaidListPerPage: 10,
			unpaidListPageNumber: 0,
			unpaidListSearchKey: "",
			unpaidListTotal: 0,
			unpaidListTotalPages: 0,
		}
	},

	created(){
  	this.loading = true;
  	this.getUnapprovedInvoiceList();
  	this.getUnpaidInvoiceList();
		// this.getOfficeList();
		this.getProjectNames();
	},

	methods: {
		clearModalData: function(){
		},
		editInvoice:function(e){
			if(this.errors.all().length>0){
				e.preventDefault()
				toastService.showErrorToast("Please fill the form with proper data and then submit")
				return;
			}
			var req = {
				invoiceNumber: this.selectedInvoiceToEdit.invoiceNumber,
				billAmount: this.selectedInvoiceToEdit.billAmount,
				vatAmount: this.selectedInvoiceToEdit.vatAmount,
				sdAmount: this.selectedInvoiceToEdit.sdAmount,
				totalAmount: this.selectedInvoiceToEdit.totalAmount,
				totalPaidAmount: this.selectedInvoiceToEdit.totalPaidAmount,
				totalDiscountAmount: this.selectedInvoiceToEdit.totalDiscount,
				remarks: this.selectedInvoiceToEdit.remarks,
			}
			var vm= this
			invoiceService.editAnInvoice(this.selectedInvoiceToEdit.id, req,(data) => {
				toastService.showSuccessToast("Successfully Edited The Invoice")
				this.approveAnInvoice(vm.selectedInvoiceToEdit.id)
			},(error) => {
				toastService.showErrorToast("Could not approve invoice " + error);
			});

		},
		passDataToModal: function(invoiceId){
			this.selectedInvoiceToEdit = JSON.parse(JSON.stringify(this.unapprovedInvoiceModalList.filter(value => {return value.id === invoiceId})[0]))
		},
		setUnapprovedListPagination: function(pageNumber, searchKey){
			this.unapprovedListSearchKey = searchKey!=null ? searchKey : this.unapprovedListSearchKey ;
			this.unapprovedListPageNumber = pageNumber;
			this.getUnapprovedInvoiceList();
		},
		getUnapprovedInvoiceList: function () {
			this.loading = true;
			invoiceService.getUnapprovedInvoiceList(this.unapprovedListPageNumber,this.unapprovedListPerPage,this.unapprovedListSearchKey,(data) => {
				this.unapprovedListTotal = data.total;
				this.unapprovedListTotalPages = data.totalPages;
				this.loading = false;
				this.createUnapprovedInvoiceListTable(data.invoiceList);
			}, (error) => {
				toastService.showErrorToast("Could not fetch invoice list" + error);
			});
		},
		setUnpaidListPagination: function(pageNumber, searchKey){
			this.unpaidListSearchKey = searchKey!=null ? searchKey : this.unpaidListSearchKey ;
			this.unpaidListPageNumber = pageNumber;
			this.loading = true;
			this.getUnpaidInvoiceList();
		},
		getUnpaidInvoiceList: function(){
			this.loading = true;
			invoiceService.getUnpaidInvoiceList(this.unpaidListPageNumber,this.unpaidListPerPage,this.unpaidListSearchKey, (data) => {
				this.unpaidListTotal = data.total;
				this.unpaidListTotalPages = data.totalPages;
				this.loading = false;
				this.unpaidInvoiceList = [];
				this.createUnpaidInvoiceListTable(data.invoiceList);
			}, (error) => {
				toastService.showErrorToast("Could not fetch invoice list" + error);
			});
		},
		createUnapprovedInvoiceListTable: function(data){
			if(data === null) return ;
			this.unapprovedInvoiceModalList = data;
			this.unapprovedInvoiceList = [];
			data.forEach((value, index) => {
				let row = new Object();
				row.invoice_id = value.id;
				row.project_name = value.subscription.subscriberProjectName;
				row.bill_generation_date = moment(value.billGenerationDate).format('DD-MM-YYYY');
				row.bill_amount = value.billAmount.toFixed(2);
				row.bill_payment_last_date = moment(value.billPaymentLastDate).format('DD-MM-YYYY');
				this.unapprovedInvoiceList.push(row);
			});
		},
		createUnpaidInvoiceListTable: function(data){
			data.forEach((value, index) => {
				let row = new Object();
				let due = value.totalAmount - value.totalPaidAmount - value.totalDiscount;
				row.invoice_id = value.id;
				row.project_name = value.subscription.subscriberProjectName;
				row.bill_generation_date = moment(value.billGenerationDate).format('DD-MM-YYYY');
				row.bill_amount = value.billAmount.toFixed(2);
				row.sd_amount = value.sdAmount.toFixed(2);
				row.total_amount = value.totalAmount.toFixed(2);
				row.total_paid_amount = value.totalPaidAmount !== null ? value.totalPaidAmount.toFixed(2) : "N/A";
				row.total_discount = value.totalDiscount !== null ? value.totalDiscount.toFixed(2) : "N/A";
				row.due_amount = due.toFixed(2);
				this.unpaidInvoiceList.push(row);
			});
		},
		approveAnInvoice: function (invoiceId) {
			invoiceService.approveAnInvoice(invoiceId, (data) => {
				// this.unapprovedInvoiceList = [];
				this.getUnapprovedInvoiceList();
				this.getUnpaidInvoiceList();
			},(error) => {
				toastService.showErrorToast("Could not approve invoice " + error);
			});
		},
		getOfficeList                     : function () {
			officeService.getOfficeList((data) => {
				this.createOfficeDropDownList(data);
			}, (error) => {
				toastService.showErrorToast("Could not fetch office list" + error);
			});
		},
		createOfficeDropDownList          : function (data) {
			data.forEach((value, index) => {
				let office = new Object();
				office.text = value.name;
				office.value = value.id;
				this.officeNameList[value.id] = value.name;
				this.officeDropDownList.push(office);
			});
		},
		getInvoicesOfAProject : function () {
			if(!this.projectId) return;
			this.loadingProjectInvoices = true;
			invoiceService.getInvoicesOfAProject(this.projectId, (data) => {
				this.projectwiseInvoiceList = [];
				this.createProjectwiseInvoiceListTable(data);
				this.loadingProjectInvoices = false;
			},(error) => {
				toastService.showErrorToast("Could not fetch invoice list " + error);
				this.loadingProjectInvoices = false;
			});
		},
		createProjectwiseInvoiceListTable : function(data){
			data.forEach((value, index) => {
				let row = new Object();
				let due = value.totalAmount - value.totalPaidAmount - value.totalDiscount;
				row.invoice_id = value.id;
				row.bill_generation_date = moment(value.billGenerationDate).format('DD-MM-YYYY');
				row.bill_amount = value.billAmount.toFixed(2);
				row.late_fee = value.lateFeeAmount.toFixed(2);
				row.total_amount = value.totalAmount.toFixed(2);
				row.total_paid_amount = value.totalPaidAmount !== null ? value.totalPaidAmount.toFixed(2) : "N/A";
				row.total_discount = value.totalDiscount !== null ? value.totalDiscount.toFixed(2) : "N/A";
				row.due_amount = due.toFixed(2);
				row.approval_status = value.approvalStatus;
				row.payment_status = value.paymentStatus;
				this.projectwiseInvoiceList.push(row);
			});
		},
		getProjectNames : function () {
			customerService.getProjectNames((data) => {
				// this.projectNames = data;
				this.createProjectNameDropDownList(data);
				this.loading = false;
			}, (error) => {
				this.loading = false;
				toastService.showErrorToast("Could not fetch project names" + error);
			});
		},
		createProjectNameDropDownList : function (data) {
			data.forEach((value) => {
				let project = new Object();
				project.text = value.name;
				project.value = value.id;
				this.projectNames[value.id] = value.name;
				this.projectNameDropDownList.push(project);
			});
		},
		downloadInvoice : function (invoiceId){
			invoiceService.downloadInvoice(invoiceId, (data) => {

			}, (error) => {
				toastService.showErrorToast("Could not download invoice");
			});
		}
	},

	computed: {
		unapprovedTableData: function () {
			return {
				items : this.unapprovedInvoiceList,
				currentPage : this.unapprovedListPageNumber,
				totalPages: this.unapprovedListTotalPages,
				searchKey: this.unapprovedListSearchKey,
				perPage: this.unapprovedListPerPage
			};
		},
		unpaidTableData: function () {
			return {
				items : this.unpaidInvoiceList,
				currentPage : this.unpaidListPageNumber,
				totalPages: this.unpaidListTotalPages,
				searchKey: this.unpaidListSearchKey,
				perPage: this.unpaidListPerPage
			}
		},
		projectwiseTableData : function () {
			return this.projectwiseInvoiceList;
		}
	},
	watch : {
  	projectId : function (newVal) {
  		if(newVal !== null) this.getInvoicesOfAProject();
		}
	}
}
</script>

<style src="vue-search-select/dist/VueSearchSelect.css"></style>
